import React, { useState, useEffect } from 'react'
import Sidebar from '../../mini-comp/Sidebar'
import Topbar from '../../mini-comp/Topbar'
import axios from 'axios';
import Cookies from 'js-cookie';
import API_BASE_URL from '../../../../config/api';
import Swal from 'sweetalert2';
import { RiEyeLine, RiEditLine, RiDeleteBinLine, RiCalendarLine, RiSearchLine } from 'react-icons/ri';

const Holidays = () => {
  const [holidays, setHolidays] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');

  const fetchHolidays = async () => {
    try {
      const token = Cookies.get('token');
      const response = await axios.get(`${API_BASE_URL}/api/v1/employees/holidays/`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      setHolidays(Array.isArray(response.data) ? response.data : []);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching holidays:', error);
      setLoading(false);
      Swal.fire('Error', 'Failed to fetch holidays.', 'error');
    }
  };

  useEffect(() => {
    fetchHolidays();
  }, []);

  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'short', day: 'numeric' };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  const filteredHolidays = holidays.filter(holiday => {
    const name = (holiday.name || holiday.title || '').toLowerCase();
    const date = formatDate(holiday.date).toLowerCase();
    const search = searchTerm.toLowerCase();
    return name.includes(search) || date.includes(search);
  });

  return (
    <div>
      <Topbar />
      <Sidebar />

      <div className="app-content-area">
        <div className="app-content-wrap">
          <div className="container-fluid">
            <div className="row mb-4 align-items-center">
              <div className="col-md-6">
                <h4 className="mb-0">Public Holidays <span className="badge bg-label-primary">{filteredHolidays.length}</span></h4>
              </div>
              <div className="col-md-6 mt-3 mt-md-0">
                <div className="input-group">
                  <span className="input-group-text bg-white border-end-0">
                    <RiSearchLine className="text-muted" />
                  </span>
                  <input
                    type="text"
                    className="form-control border-start-0"
                    placeholder="Search by holiday name or date..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </div>
              </div>
            </div>

            {loading ? (
              <div className="row justify-content-center mt-5">
                <div className="col-auto text-center">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                  <p className="mt-2">Fetching holidays...</p>
                </div>
              </div>
            ) : (
              <div className="row">
                {filteredHolidays.length > 0 ? (
                  filteredHolidays.map((holiday) => (
                    <div key={holiday.id} className="col-xxl-3 col-xl-4 col-md-6 mb-4">
                      <div className="card h-100 shadow-sm border-0 border-top border-4 border-primary">
                        <div className="card-body">
                          <div className="d-flex justify-content-between align-items-start mb-3">
                            <div className="bg-primary-transparent text-primary p-2 rounded">
                              <RiCalendarLine size={24} />
                            </div>
                            <span className="badge bg-label-secondary">{formatDate(holiday.date)}</span>
                          </div>
                          <h5 className="card-title mb-2 text-dark">{holiday.name || holiday.title}</h5>
                          <p className="card-text text-muted mb-0">
                            {holiday.description || 'No description provided for this public holiday.'}
                          </p>
                        </div>
                        <div className="card-footer bg-transparent border-0 pt-0 pb-3">
                          <div className="d-flex gap-2">
                            <button className="btn btn-sm btn-icon btn-info-light">
                              <RiEditLine />
                            </button>
                            <button className="btn btn-sm btn-icon btn-danger-light">
                              <RiDeleteBinLine />
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="col-12 text-center py-5">
                    <div className="mb-3">
                      <RiSearchLine size={64} className="text-muted opacity-25" />
                    </div>
                    <h5 className="text-muted">No holidays found</h5>
                    <p className="text-muted">
                      {searchTerm ? `No results matching "${searchTerm}"` : "There are currenty no public holidays scheduled."}
                    </p>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Holidays